import api from "@/lib/axios";

export const fieldConditionsService = {
  async getFieldConditions() {
    const response = await api.get('/field-conditions');
    return response.data;
  },

  async evaluateConditions(formId, values) {
    const response = await api.post(`/api/forms/${formId}/evaluate-conditions`, {
      values
    });
    return response.data;
  }
}; 